var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-select',{attrs:{"options":_vm.localesMapped},on:{"input":function($event){return _vm.setLocale(_vm.localeKey)}},model:{value:(_vm.localeKey),callback:function ($$v) {_vm.localeKey=$$v},expression:"localeKey"}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057632ec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/_overrides/LocaleDropdown.vue
// module id = 1Usu
// module chunks = 44